var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5L1 12.5H11L10 10.5L9.6758 5.31287C9.57699 3.73176 8.26584 2.5 6.68165 2.5H5.31835C3.73416 2.5 2.42301 3.73176 2.3242 5.31287L2 10.5Z",
    stroke: "#C7A267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V1.80278C5 1.60535 5.05844 1.41234 5.16795 1.24808V1.24808C5.56377 0.654342 6.43623 0.654342 6.83205 1.24808V1.24808C6.94156 1.41234 7 1.60535 7 1.80278V3",
    stroke: "#C7A267",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13V13.3333C5 13.5497 5.07018 13.7602 5.2 13.9333V13.9333C5.6 14.4667 6.4 14.4667 6.8 13.9333V13.9333C6.92982 13.7602 7 13.5497 7 13.3333V13",
    stroke: "#C7A267",
    strokeWidth: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.c4c69b7ba92a439a91e7052743321405.svg";
export { ForwardRef as ReactComponent };